import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
} from "react";
import { signIn as sendSignInRequest } from "../api/auth";
import { getUser as getUserRequest } from "../api/auth";
import { sendToken as sendTokenRequest } from "../api/auth";
import { logOut as logOutRequest } from "../api/auth";

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      const result = await getUser();
      if (result.isOk) {
        setUser(result.data);
      }
      setLoading(false);
    })();
  }, []);

  const signIn = useCallback(async (email, password) => {
    const result = await sendSignInRequest(email, password);
    if (result.isOk) {
      return result;
    } else
      return {
        isOk: false,
        message: result.message,
      };
  }, []);

  const sendToken = useCallback(async (g, t) => {
    const result = await sendTokenRequest(g, t);
    if (result.isOk) {
      setUser(result.data);
    }

    return result;
  }, []);

  const signOut = useCallback(async () => {
    const result = await logOutRequest();
    setUser();

    sessionStorage.removeItem("returnTo");
  }, []);

  const getUser = useCallback(async () => {
    const result = await getUserRequest();
    if (result.isOk) {
      var userData = result.data;
    } else {
      return {
        isOk: false,
        message: "Authentication failed",
      };
    }

    setUser(userData);
    if (userData) {
      return {
        isOk: true,
        data: userData,
      };
    } else
      return {
        isOk: false,
        message: "Authentication failed",
      };
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, signIn, sendToken, signOut, getUser, loading }}
      {...props}
    />
  );
}

const AuthContext = createContext({});
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
